export default "__VITE_ASSET__D$4_UfWe__"